module.exports = __webpack_public_path__ + "assets/img/price-sm.f010baef.jpg";